<template>
    <v-container 
        align-content-start
		pt-4
		mt-5
		mb-2
        >
        <v-layout row>
            <v-flex 
            xs12
            md4
            ma-1>
            <create-group/>
            </v-flex>
            <v-spacer/>
        </v-layout>
    </v-container>
</template>

<script>
import {mapState} from 'vuex'
import CreateGroup from './CreateGroup'

export default {
	components: {
        CreateGroup,
	},
	data () {
		return {
            route: "groups-create",
		}
	},
	computed: {
		...mapState([
			'isUserLoggedIn',
		])
	},
	async created () {
		if (!this.isUserLoggedIn) {
			this.$router.push({
				name: 'login'
			})
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CreateGroup/CreateGroupIndex.vue